/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetAnimalVaccinationStatusQueryResponse, GetAnimalVaccinationStatusPathParams, GetAnimalVaccinationStatusQueryParams, GetAnimalVaccinationStatus400, GetAnimalVaccinationStatus401, GetAnimalVaccinationStatus403, GetAnimalVaccinationStatus404, GetAnimalVaccinationStatus409, GetAnimalVaccinationStatus500 } from "../../types/livestockController/GetAnimalVaccinationStatus.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetAnimalVaccinationStatusUrl(organizationId: GetAnimalVaccinationStatusPathParams["organizationId"], animalId: GetAnimalVaccinationStatusPathParams["animalId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/livestock/animals/${animalId}/vaccination-status` as const }
  return res
}

/**
 * @summary Per-animal standing against every active vaccination rule (due, upcoming, too young, window missed, done)
 * {@link /api/organizations/:organizationId/livestock/animals/:animalId/vaccination-status}
 */
export async function getAnimalVaccinationStatus(organizationId: GetAnimalVaccinationStatusPathParams["organizationId"], animalId: GetAnimalVaccinationStatusPathParams["animalId"], params?: GetAnimalVaccinationStatusQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetAnimalVaccinationStatusQueryResponse, ResponseErrorConfig<GetAnimalVaccinationStatus400 | GetAnimalVaccinationStatus401 | GetAnimalVaccinationStatus403 | GetAnimalVaccinationStatus404 | GetAnimalVaccinationStatus409 | GetAnimalVaccinationStatus500>, unknown>({ method : "GET", url : getGetAnimalVaccinationStatusUrl(organizationId, animalId).url.toString(), params, ... requestConfig })
  return res.data
}